// src/layouts/AdminLayout.tsx
import { Outlet, NavLink, useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Avatar,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Toolbar,
  AppBar,
  Button,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useState, useEffect } from "react";
import { useUiConfig } from "../utility/uiconfig";
import logo from "../assets/images/logo.png";
import logo_icon from "../assets/images/favicon_Sandhata.png";
import { useMsal } from "@azure/msal-react";
import { getUserProfile } from "../utility/fetchUserProfile";


const drawerWidth = 210;

export default function AdminLayout() {
  const { domain } = useParams(); // get current domain from URL
  const [selectedDomain, setSelectedDomain] = useState(null);
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState({ name: "", image: "" })
  const navigate = useNavigate();
  const uiConfig = useUiConfig();

  // Auto-select domain based on URL param
  useEffect(() => {
    if (domain) {
      setSelectedDomain(domain);
    }
  }, [domain]);

  useEffect(() => {
    const fetchProfile = async () => {
      if (accounts.length === 0) return;
      try {
        const profile = await getUserProfile(instance, accounts[0]);
        setUser(profile);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProfile();
  }, [accounts, instance]);

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect({ postLogoutRedirectUri: "/admin-login" });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const toggleDomain = (d) => {
    setSelectedDomain(selectedDomain === d ? null : d);
  };

  const handleAppBarClick = (e, idx) => {
    const appBarTitle = e.target.innerText;
    if (appBarTitle === "MATURITY ASSESSMENT") {
      navigate(`/admin/${domain}/view-reports/`);
    }
    else if (appBarTitle === 'Home') {
      navigate(`/admin/select-domain`)
    } else {
      navigate(`/final-page`);
    }
  }

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      {/* <Box
        sx={{
          width: drawerWidth,
          bgcolor: "#ffffff",
          borderRight: "1px solid #ddd",
          display: "flex",
          flexDirection: "column",
          position: "sticky",
          top: 0,
          height: "100vh",
          overflowY: "auto",

        }}
      > */}
        {/* Logo */}
   
        {/* Domains heading */}
        {/* <Box sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#555" }}>
            Domains
          </Typography>
        </Box> */}

        {/* Domain list */}
        {/* <List sx={{ flexGrow: 1 }}>
          {Object.keys(uiConfig).map((d) => (
            <Box key={d}>
              
              <ListItemButton
                onClick={() => toggleDomain(d)}
              >
                <ListItemText primary={d.toUpperCase()} />
                {selectedDomain === d ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItemButton>

              <Collapse
                in={selectedDomain === d}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>

                  <ListItemButton
                    component={NavLink}
                    to={`/admin/${d}/questionaire`}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Questionaire" />
                  </ListItemButton>

                  <ListItemButton
                    component={NavLink}
                    to={`/admin/${d}/category`}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="Category" />
                  </ListItemButton>

                </List>
              </Collapse>
            </Box>
          ))}
          <ListItemButton
            component={NavLink}
            to="/admin/score-levels"
            sx={{
              borderBottom: "1px solid #eee"
            }}
          >
            <ListItemText primary="Score/Maturity Level" />
          </ListItemButton>
        </List> */}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            fontSize: "12px"
          }}
        >
          {
            domain &&
          <Button sx={{color: "black", fontSize: "12px"}}  onClick={() => {navigate('/instructions')}}>Preview instructions</Button>
          }
        </Box> */}
      {/* </Box>  */}

      {/* Main Area */}

      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <Box
          sx={{
            display: "flex",
          }}
        >
          <img src={logo} alt="logo" width={150} style={{"padding": "20px"}}/>
        </Box>
        {/* Top AppBar */}
        <AppBar
          position="static"
          sx={{
            bgcolor: "#ffffff",
            color: "black",
            borderBottom: "1px solid #ddd",
            height: 64,
            px: 3,
            boxShadow: "none",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              height: "100%",
              p: 0,
              mr: 0,
              ml: 0,
            }}
          >
            {/* Left section */}

            <Box sx={{ display: "flex", gap: 3 }}>
              {["Home"].map((menu, idx) => {
                if (idx === 1 && !domain) return null;
                return (<Button
                  onClick={(e) => handleAppBarClick(e, idx)}
                  key={menu}
                  sx={{
                    color: "black",
                    p: 0,
                    m: 0,
                    cursor: "pointer",
                    fontWeight: 500,
                    "&:hover": { color: "#1976d2" },
                  }}
                >
                  {menu}
                </Button>)
              })}
            </Box>


            {/* Right section */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mr: 0, gap: 2 }}>
              {user.image ? (
                <Avatar src={user.image} />
              ) : (
                <Avatar sx={{ bgcolor: "#1976d2" }}>
                  {user.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase()}
                </Avatar>
              )}

              <Typography sx={{ fontWeight: 500 }}>{user.name}</Typography>

              <Button
                onClick={handleLogout}
                sx={{
                  textTransform: "none",
                  color: "#1976d2",
                  border: "1px solid #1976d2",
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  px: 2,
                  py: 0.5,
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    color: "#fff",
                  },
                }}
              >
                Logout
              </Button>
            </Box>

          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: "auto",
          }}
        >
          <Outlet context={{ uiConfig }} />
        </Box>
      </Box>
    </Box>
  );
}